import { useNavigate } from "react-router-dom";
import SiteText from './SiteText.jsx';
import Styles from './Styles.jsx';
import heroImage from './assets/Hero/Hero-Image.jpg'

const HeroText = () => {
    const navigate = useNavigate();

    return <div className="lg:w-1/2 max-lg:bg-tertiary lg:bg-tertiary/90  max-lg:h-[500px] lg:h-[700px] flex flex-col items-start justify-center px-8 lg:px-64">
        <h1 className="text-5xl text-primary pb-4 font-bold">
            {SiteText.Hero.Title}
        </h1>
        <h3 className="text-3xl text-primary py-2">
            {SiteText.Hero.SubTitle}
        </h3>
        <p className="pt-2">
            {SiteText.Hero.Description(SiteText.Global.Name)}
        </p>
        <button 
            className={Styles.Global.Button}
            onClick={() => navigate(SiteText.SitePaths.GetQuote)}
        >
            {SiteText.Global.GetQuote}
        </button>
    </div>
}

const Hero = () => {
    return <div>
        <div className="lg:hidden">
            <img src={heroImage} alt=""/>
            <HeroText />
        </div>
        <div className="bg-hero bg-cover bg-center max-lg:hidden">
            <HeroText />
        </div>
    </div>
};

export default Hero;